import React, { useState, useEffect, useMemo } from "react"
import lodash from "lodash"
import { useRecoilState } from "recoil"

import { useFieldContext } from '../../../../../1stlog-ui/src/components/Field'
import { isOpenStateFamily } from "./state"

const useAddressBookDialog = () => {
  const { prefix } = useFieldContext()

  const [isOpen, setIsOpen] = useRecoilState(isOpenStateFamily(prefix))
  // save new address

  // update existing address

  // load all addresses

  const open = () => setIsOpen(true)

  const close = () => setIsOpen(false)

  return { isOpen, open, close }
}

export default useAddressBookDialog
